// <global items>
export const SET_IS_LOADING = 'SET_IS_LOADING';
export const SET_NODE_DATA = 'SET_NODE_DATA';
// </global items>
